import React, { useEffect, useState, useRef } from 'react';
// import { NumericFormat } from 'react-number-format';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Mousewheel, Keyboard, Virtual } from 'swiper';

import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';

import PropTypes from 'prop-types';

import Slider, { SliderThumb } from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import theme from './sub/theme_app';
import axiosRequest from './sub/axiosRequest';

import 'swiper/swiper.min.css';
import 'swiper/swiper-bundle.min.css';
import './../css/app.css';
import Slideimg from './../icons/slide-credit-decor.svg';

const formatNumber = (numStr) => {
  // Удаляем все нецифровые символы кроме первого минуса
  const cleaned = numStr.replace(/[^\d-]/g, '').replace(/(?!^)-/g, '');
  const parts = cleaned.split('-');
  const numericPart = parts.join(''); // Объединяем части без минусов
  
  if (numericPart === '') return '';
  
  // Форматируем с разделителями
  const formatted = numericPart
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    .replace(/^0+(\d)/, '$1'); // Убираем ведущие нули

  // Восстанавливаем минус если был
  return (cleaned.startsWith('-') ? '-' : '') + formatted;
};

function App(data) {

  // console.log(window);

  const [swiperRefActiveObject, setSwiperRefActiveObject] = useState(null);
  const [descMaxLoanAmount, setDescMaxLoanAmount] = useState(0);

  const [activeCheckbox, setActiveCheckbox] = useState(0);
  const [info, setInfo] = useState({});

  const [houseCostValue, setHouseCostValue] = useState(1000);
  const [rawHouseCostValue, setRawHouseCostValue] = useState(1000);
  const [houseCostLimit, setHouseCostLimit] = useState({
      min: 1000,
      max: 10000
  });

  const [initialPaymentValue, setInitialPaymentValue] = useState(1000);
  const [rawInitialPaymentValue, setRawInitialPaymentValue] = useState(1000);
  const [initialPaymentPercentValue, setInitialPaymentPercentValue] = useState(1);
  const [initialPaymentLimit, setInitialPaymentLimit] = useState({
      min: 1000,
      max: 10000
  });

  const [loanTermValue, setLoanTermValue] = useState(1);
  const [loanTermLimit, setLoanTermLimit] = useState({
      min: 1,
      max: 100
  });

  const [rerenderHouseCost, setRerenderHouseCost] = useState(1);
  const [rerenderInitialPayment, setRerenderInitialPayment] = useState(1);
  const [rerenderLoanTerm, setRerenderLoanTerm] = useState(1);

  const [suffixWidthHouseCost, setSuffixWidthHouseCost] = useState(0);
  const [suffixWidthInitialPayment, setSuffixWidthInitialPayment] = useState(0);
  const [suffixWidthLoanTerm, setSuffixWidthLoanTerm] = useState(0);
  const [yearFormLoanTerm, setYearFormLoanTerm] = useState(null);

  const [pickedType, setPickedType] = useState('sber');
  const [pickedMortgage, setPickedMortgage] = useState('base');


  useEffect(() => {

    // let data = {
    //   sber: {
    //     base: {
    //       percent: 20.3,
    //       first: 25.1,
    //       term: 30,
    //       min: 300000,
    //       max: 100000000,
    //       max_loan_amount: 12000000
    //     },
    //     gos: {
    //       percent: 8,
    //       first: 1,
    //       term: 30,
    //       min: 300000,
    //       max: 50000000,
    //       max_loan_amount: 12000000
    //     },
    //     fam: {
    //       percent: 6,
    //       first: 20.1,
    //       term: 30,
    //       min: 300000,
    //       max: 30000000,
    //       max_loan_amount: 12000000
    //     },
    //     it: {
    //       percent: 6,
    //       first: 20.1,
    //       term: 30,
    //       min: 300000,
    //       max: 9000000,
    //       max_loan_amount: 12000000
    //     },
    //   },
    //   domrf: {
    //     base: {
    //       percent: 19.2,
    //       first: 20,
    //       term: 30,
    //       min: 1000000,
    //       max: 30000000,
    //       max_loan_amount: 12000000
    //     },
    //     gos: {
    //       percent: 8,
    //       first: 1,
    //       term: 30,
    //       min: 300000,
    //       max: 50000000,
    //       max_loan_amount: 12000000
    //     },
    //     fam: {
    //       percent: 6,
    //       first: 20.1,
    //       term: 30,
    //       min: 300000,
    //       max: 30000000,
    //       max_loan_amount: 12000000
    //     },
    //     it: {
    //       percent: 6,
    //       first: 30,
    //       term: 15,
    //       min: 300000,
    //       max: 5000000,
    //       max_loan_amount: 12000000
    //     },
    //   }
    // };
    axiosRequest('', '', (response) => {
      // console.log(response);
      
      data = response.data;
      setInfo(data);

      let ft = data[pickedType][pickedMortgage];
      setHouseCostValue(ft.min);
      setRawHouseCostValue(formatNumber(String(ft.min).toLocaleString('ru')));
      setHouseCostLimit({
        min: ft.min,
        max: ft.max
      });

      setInitialPaymentValue(ft.min / 100 * ft.first);
      setRawInitialPaymentValue(formatNumber(String(ft.min / 100 * ft.first).toLocaleString('ru')));
      setInitialPaymentPercentValue(ft.first);
      setInitialPaymentLimit({
        min: ft.min / 100 * ft.first,
        max: ft.min / 100 * 90
      });

      setLoanTermValue(1);
      setLoanTermLimit({
        min: 1,
        max: ft.term
      });

      setDescMaxLoanAmount(ft.max_loan_amount);
    });
  }, []);
  
  useEffect(() => {
    // console.log(info);
    // console.log(houseCostValue);
    if (Object.keys(info).length) {
      let ft  = info[pickedType][pickedMortgage];
      setInitialPaymentLimit({
        min: houseCostValue / 100 * ft.first,
        max: houseCostValue / 100 * 90
      }); 
      if (initialPaymentValue < houseCostValue / 100 * ft.first) {
        setInitialPaymentValue(houseCostValue / 100 * ft.first);
        setRawInitialPaymentValue(formatNumber(String(houseCostValue / 100 * ft.first).toLocaleString('ru')));

        setInitialPaymentPercentValue((100 / houseCostValue * (houseCostValue / 100 * ft.first)).toFixed(1));
      } else if (initialPaymentValue > houseCostValue / 100 * 90) {
        setInitialPaymentValue(houseCostValue / 100 * 90);
        setRawInitialPaymentValue(formatNumber(String(houseCostValue / 100 * 90).toLocaleString('ru')));

        setInitialPaymentPercentValue((100 / houseCostValue * houseCostValue).toFixed(1));
      } else {
        setInitialPaymentPercentValue((100 / houseCostValue * initialPaymentValue).toFixed(1));
      }
      setRerenderInitialPayment(rerenderInitialPayment + 1);
    }
  }, [houseCostValue]);

  useEffect(() => {
    if (Object.keys(info).length) {
      let ft  = info[pickedType][pickedMortgage];
      if (initialPaymentValue < houseCostValue / 100 * ft.first) {
        setInitialPaymentPercentValue((100 / houseCostValue * (houseCostValue / 100 * ft.first)).toFixed(1));
      } else if (initialPaymentValue > houseCostValue) {
        setInitialPaymentPercentValue((100 / houseCostValue * houseCostValue).toFixed(1));
      } else {
        setInitialPaymentPercentValue((100 / houseCostValue * initialPaymentValue).toFixed(1));
      }
    }
  }, [initialPaymentValue]);

  useEffect(() => {
    if (Object.keys(info).length) {
      let ft  = info[pickedType][pickedMortgage];
    }
  }, [loanTermValue]);

  useEffect(() => {
    if (Object.keys(info).length) {
      let ft = info[pickedType][pickedMortgage];

      let currhouseCost = houseCostValue;
      if (ft.min > houseCostValue) {
        setHouseCostValue(ft.min);
        setRawHouseCostValue(formatNumber(String(ft.min).toLocaleString('ru')));
        currhouseCost = ft.min;
      } else if (ft.max < houseCostValue) {
        setHouseCostValue(ft.max);
        setRawHouseCostValue(formatNumber(String(ft.max).toLocaleString('ru')));
        currhouseCost = ft.max;
      }
      setHouseCostLimit({
        min: ft.min,
        max: ft.max
      });

      if (initialPaymentValue < currhouseCost / 100 * ft.first) {
        setInitialPaymentValue(currhouseCost / 100 * ft.first);
        setRawInitialPaymentValue(formatNumber(String(currhouseCost / 100 * ft.first).toLocaleString('ru')));

        setInitialPaymentPercentValue((100 / currhouseCost * (currhouseCost / 100 * ft.first)).toFixed(1));
      } else if (initialPaymentValue > currhouseCost / 100 * 90) {
        setInitialPaymentValue(currhouseCost / 100 * 90);
        setRawInitialPaymentValue(formatNumber(String(currhouseCost / 100 * ft.first).toLocaleString('ru')));

        setInitialPaymentPercentValue((100 / currhouseCost * currhouseCost).toFixed(1));
      } else {
        setInitialPaymentPercentValue((100 / currhouseCost * initialPaymentValue).toFixed(1));
      }
      setInitialPaymentLimit({
        min: ft.min / 100 * ft.first,
        max: ft.min / 100 * 90
      });

      if (loanTermValue > ft.term) {
        setLoanTermValue(ft.term);
      } else {
        
      }
      setLoanTermValue(1);
      setLoanTermLimit({
        min: 1,
        max: ft.term
      });

      setDescMaxLoanAmount(ft.max_loan_amount);
    }
  }, [pickedType, pickedMortgage]);

  function calculateLoan(housePrice, downPayment, years, annualRate, type) {
    // Рассчет основных параметров
    const principal = housePrice - downPayment; // Тело кредита
    const monthlyRate = annualRate / 12 / 100; // Месячная ставка
    const months = years * 12; // Срок в месяцах

    // Расчет ежемесячного платежа по формуле аннуитета
    const monthlyPayment = (principal * monthlyRate) / 
                          (1 - Math.pow(1 + monthlyRate, -months));

    // Расчет общей суммы выплат и переплаты
    const totalPaid = monthlyPayment * months;
    const overpayment = totalPaid - principal;
    if (type == 'monthlyPayment') {
      return Number(monthlyPayment.toFixed(0));
    } else if (type == 'overpayment') {
      return Number(overpayment.toFixed(0));
    } else {
      return {
        monthlyPayment: Number(monthlyPayment.toFixed(0)), // Округляем до копеек
        overpayment: Number(overpayment.toFixed(0))
    };
    }
  }

// // Пример использования
// const result = calculateLoan(300000, 75300, 1, 8);
// // console.log("Ежемесячный платеж:", result.monthlyPayment); // 36040.52
// // console.log("Переплата:", result.overpayment);   

  useEffect(() => {
    const width = getTextWidth(rawHouseCostValue, '16px Circe-Regular');
    setSuffixWidthHouseCost(width);
  }, [rawHouseCostValue]);

  useEffect(() => {
    const width = getTextWidth(rawInitialPaymentValue, '16px Circe-Regular');
    setSuffixWidthInitialPayment(width);
  }, [rawInitialPaymentValue]);

  useEffect(() => {
    const width = getTextWidth(loanTermValue, '16px Circe-Regular');
    const yearForm = getYearWord(loanTermValue);
    setSuffixWidthLoanTerm(width);
    setYearFormLoanTerm(yearForm);
  }, [loanTermValue]);
  
  const setNumberHouseCost = ({ target }) => {
    // // console.log(target);
    let { value, min, max } = target;
    // console.log(value);
    value = Math.max(Number(min), Math.min(Number(max), Number(value.replace(/ /g, ''))));
    // // const input = e.target.value;
    // const newRawValue = value.replace(/ /g, '');
    // // console.log(newRawValue);
    // // console.log(formatNumber(input));
    // // setRawValue(newRawValue);
    // // setValue(formatNumber(newRawValue));


    // setHouseCostValue(newRawValue);
    // setRawHouseCostValue(formatNumber(newRawValue));
    // formatNumber(String(ft.min).toLocaleString('ru'))
    // console.log(value);
    
    setHouseCostValue(value);
    setRawHouseCostValue(formatNumber(String(value).toLocaleString('ru')));
  };
  const setNumberInitialPayment = ({ target }) => {
    // let { value, min, max } = target;
    // value = Math.max(Number(min), Math.min(Number(max), Number(value)));

    // setInitialPaymentValue(value);
    // setRawInitialPaymentValue();

    let { value, min, max } = target;
    // console.log(value);
    value = Math.max(Number(min), Math.min(Number(max), Number(value.replace(/ /g, ''))));
    setInitialPaymentValue(value);
    setRawInitialPaymentValue(formatNumber(String(value).toLocaleString('ru')))
  };
  const setNumberLoanTerm = ({ target }) => {
    let { value, min, max } = target;
    value = Math.max(Number(min), Math.min(Number(max), Number(value)));

    setLoanTermValue(value);
  };



  const setPositionHouseCost = (event, value) => {
    // console.log(value);
    // // console.log(value.toLocaleString('ru'));
    let rn = Number(value);
    // // console.log(rn);
    
    setHouseCostValue(rn);
    setRawHouseCostValue(formatNumber(String(value).toLocaleString('ru')));
  };
  const setPositionInitialPayment = (event, value) => {
    let rn = Number(value);
    setInitialPaymentValue(value);
    setRawInitialPaymentValue(formatNumber(String(value).toLocaleString('ru')));
  };
  const setPositionLoanTerm = (event, value) => {
    setLoanTermValue(value);
  };



  // const handleOnBlurHouseCost = () => {
  //   if (houseCostValue < houseCostLimit.min) {
  //     // console.log(houseCostValue);
      
  //     setHouseCostValue(houseCostLimit.min);
  //   }
  // };
  // const handleOnBlurInitialPayment = () => {
  //   if (initialPaymentValue < initialPaymentLimit.min) {
  //     setInitialPaymentValue(initialPaymentLimit.min);
  //   }
  // };
  // const handleOnBlurLoanTerm = () => {
  //   if (loanTermValue < loanTermLimit.min) {
  //     setLoanTermValue(loanTermLimit.min);
  //   }
  // };

  function getTextWidth(text, font) {
    // re-use canvas object for better performance
    var canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
    var context = canvas.getContext("2d");
    // // console.log(context);
    
    context.font = font;
    var metrics = context.measureText(text);
    return metrics.width;
  }

  function getYearWord(number) {
    const num = Math.abs(number) % 100;
    const lastDigit = num % 10;
    
    if (num > 10 && num < 20) return 'лет';
    if (lastDigit === 1) return 'год';
    if (lastDigit > 1 && lastDigit < 5) return 'года';
    return 'лет';
  }

  // const Icon = ({ name, color, size }) => (
  //   <svg className={`icon icon-${name}`} fill={color} width={size} height={size}>
  //     <use xlinkHref={`${Icons}#icon-${name}`} />
  //   </svg>
  // );


  // const [value, setValue] = useState(1000);
  // const [rawValue, setRawValue] = useState('1 000');

  // const formatNumber = (numStr) => {
  //   // Удаляем все нецифровые символы кроме первого минуса
  //   const cleaned = numStr.replace(/[^\d-]/g, '').replace(/(?!^)-/g, '');
  //   const parts = cleaned.split('-');
  //   const numericPart = parts.join(''); // Объединяем части без минусов
    
  //   if (numericPart === '') return '';
    
  //   // Форматируем с разделителями
  //   const formatted = numericPart
  //     .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  //     .replace(/^0+(\d)/, '$1'); // Убираем ведущие нули

  //   // Восстанавливаем минус если был
  //   return (cleaned.startsWith('-') ? '-' : '') + formatted;
  // };

  // const handleChange = (e) => {
  //   const input = e.target.value;
  //   const newRawValue = input.replace(/ /g, '');
  //   // console.log(newRawValue);
  //   // console.log(formatNumber(input));
  //   setValue(newRawValue);
  //   setRawValue(formatNumber(input));
  // };

  // Для внешнего использования числового значения
  // useEffect(() => {
  //   const numericValue = parseInt(rawValue, 10) || 0;
  //   // console.log('Numeric value:', numericValue);
  // }, [rawValue]);

  return (
      <div className='crediting-main crediting__container'>
          <div className='crediting-header'>
              <div className='Manrope_Bold fcldg crediting-title'>Кредитование</div>
              <div className='Circe_Regular fcg fs15 crediting-description'>Что, если мы скажем вам, что оформлять ипотеку может быть совсем не страшно, а выплачивать ее — легко и комфортно?</div>
          </div>
          <div  className='crediting-block'>
              <div className='crediting-left'>
                  <div className='crediting-left-top'>
                      <div className='crediting-checkboxes'>
                          <div onClick={() => setPickedType('sber')} className={`crediting-checkbox checkbox-sber ${pickedType == 'sber' ? 'checkbox-active' : ''}`}>
                              <svg width="114" height="18" viewBox="0 0 114 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M50.9736 5.22195L53.3491 3.54004H45.3939V13.6161H53.3491V11.9328H47.6662V9.36108H52.5233V7.67916H47.6662V5.22195H50.9736Z" fill="#4D4B4C"></path>
                                  <path d="M39.3837 7.46404H36.6277V5.22195H41.0366L43.4136 3.54004H34.3555V13.6161H39.0902C41.7429 13.6161 43.275 12.4609 43.275 10.4493C43.275 8.52012 41.8978 7.46404 39.3837 7.46404ZM39.0047 11.9328H36.6277V9.14595H39.0047C40.4512 9.14595 41.1222 9.60833 41.1222 10.5485C41.1222 11.4886 40.3996 11.9328 39.0047 11.9328Z" fill="#4D4B4C"></path>
                                  <path d="M59.7899 3.54004H55.468V13.6161H57.7403V10.7622H59.8076C62.5621 10.7622 64.2843 9.37784 64.2843 7.15112C64.2843 4.9244 62.5621 3.54004 59.7899 3.54004ZM59.7383 9.08029H57.7241V5.22195H59.7383C61.2025 5.22195 61.9944 5.91483 61.9944 7.15112C61.9944 8.38741 61.2025 9.08029 59.7383 9.08029Z" fill="#4D4B4C"></path>
                                  <path d="M30.4626 11.4382C29.861 11.7525 29.1886 11.9174 28.5 11.9174C26.4503 11.9174 24.9699 10.5148 24.9699 8.58567C24.9699 6.6565 26.4503 5.25398 28.5 5.25398C29.2402 5.23861 29.9642 5.46911 30.5658 5.8812L32.2025 4.72733L32.0993 4.62815C31.1527 3.81932 29.8772 3.40723 28.4307 3.40723C26.8647 3.40723 25.4344 3.91851 24.4022 4.84188C23.3686 5.79878 22.7832 7.13425 22.8171 8.52002C22.7994 9.92114 23.3686 11.2734 24.4022 12.2624C25.486 13.2361 26.9325 13.7809 28.4144 13.7474C30.0497 13.7474 31.4785 13.2025 32.4429 12.2135L30.9802 11.1742L30.4626 11.4382Z" fill="#4D4B4C"></path>
                                  <path d="M91.6135 3.5568V13.6315H93.8858V9.50915H98.7252V13.6315H100.999V3.5568H98.7252V7.69593H93.8858V3.5568H91.6135ZM87.7045 13.6315H90.0977L85.6549 3.5568H83.3472L78.8189 13.6315H81.1088L82.0216 11.6032H86.8433L87.7045 13.6315ZM82.7102 9.92125L84.4664 5.88131L86.1193 9.92125H82.7102ZM106.096 9.55944H107.508L110.986 13.6161H113.913L109.264 8.40417L113.328 3.54004H110.728L107.353 7.86077H106.096V3.54004H103.823V13.6161H106.096V9.55944ZM71.3105 7.4808V5.23871H77.2514V3.5568H69.0367V13.6315H73.773C76.4242 13.6315 77.9577 12.4776 77.9577 10.4661C77.9577 8.53688 76.5805 7.4808 74.0649 7.4808H71.3105ZM71.3105 11.9496V9.16271H73.6875C75.1325 9.16271 75.8049 9.6251 75.8049 10.5652C75.8049 11.5054 75.0986 11.9664 73.6875 11.9664H71.3105V11.9496Z" fill="#4D4B4C"></path>
                                  <path d="M15.7054 3.47363C16.1182 3.98491 16.4633 4.54508 16.7552 5.13878L8.80006 10.7615L5.45874 8.74986V6.34294L8.78236 8.33777L15.7054 3.47363Z" fill="#4D4B4C"></path>
                                  <path d="M2.06586 8.58511C2.06586 8.46916 2.06586 8.37138 2.08356 8.25543L0.0693303 8.15625C0.0693303 8.28896 0.0516357 8.43703 0.0516357 8.56835C0.0516357 10.8775 1.03368 12.9715 2.61734 14.4886L4.04618 13.1196C2.82378 11.9657 2.06586 10.3662 2.06586 8.58511Z" fill="#4D4B4C"></path>
                                  <path d="M8.78238 2.15378C8.90329 2.15378 9.00651 2.15378 9.12743 2.17054L9.23064 0.241372C9.09204 0.241372 8.93721 0.224609 8.80008 0.224609C6.3892 0.224609 4.20244 1.16475 2.61731 2.68182L4.04614 4.05082C5.25232 2.88019 6.9392 2.15378 8.78238 2.15378Z" fill="#4D4B4C"></path>
                                  <path d="M8.78237 15.0172C8.66146 15.0172 8.55824 15.0172 8.43732 15.0004L8.33411 16.9296C8.47271 16.9296 8.62754 16.9463 8.76467 16.9463C11.1756 16.9463 13.3638 16.0062 14.9474 14.4891L13.5186 13.1201C12.3124 14.3075 10.6418 15.0172 8.78237 15.0172Z" fill="#4D4B4C"></path>
                                  <path d="M12.5706 3.27568L14.2752 2.07152C12.777 0.917652 10.866 0.208008 8.78247 0.208008V2.13718C10.1951 2.15394 11.503 2.56604 12.5706 3.27568Z" fill="#4D4B4C"></path>
                                  <path d="M17.5309 8.58527C17.5309 8.07399 17.4793 7.57948 17.3923 7.08496L15.5152 8.42043C15.5152 8.46933 15.5152 8.53638 15.5152 8.58527C15.5152 10.4823 14.6541 12.181 13.2946 13.3516L14.6541 14.7863C16.4117 13.2692 17.5309 11.0425 17.5309 8.58527Z" fill="#4D4B4C"></path>
                                  <path d="M8.78246 15.0172C6.80215 15.0172 5.02827 14.193 3.80588 12.8896L2.30774 14.193C3.90909 15.8917 6.21676 16.9464 8.78246 16.9464V15.0172Z" fill="#4D4B4C"></path>
                                  <path d="M4.288 3.81942L2.927 2.38477C1.15312 3.9186 0.0516357 6.12856 0.0516357 8.58577H2.06586C2.06586 6.70549 2.927 4.99145 4.288 3.81942Z" fill="#4D4B4C"></path>
                              </svg>
                          </div>
                          <div onClick={() => setPickedType('domrf')} className={`crediting-checkbox checkbox-domrf ${pickedType == 'domrf' ? 'checkbox-active' : ''}`}>
                              <svg width="82" height="18" viewBox="0 0 82 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <g id="logo-DOM-RF 2" clip-path="url(#clip0_436_4639)">
                                      <path id="Vector" d="M39.921 0L39.921 18H42.0789V0H39.921Z" fill="#4D4B4C"></path>
                                      <path id="Vector_2" d="M46.3948 14.0557H48.5849V11.8017H61.0374V4.09082H46.3948V14.0557ZM48.5849 6.04825H58.8472V9.84435H48.5849V6.04825Z" fill="#4D4B4C"></path>
                                      <path id="Vector_3" d="M63.1042 11.8017H71.3642V14.0557H73.6169V11.8017H81.8768V4.09082H63.1042V11.8017ZM73.6169 6.04825H79.7492V9.84435H73.6169V6.04825ZM65.2943 6.04825H71.3642V9.84435H65.2943V6.04825Z" fill="#4D4B4C"></path>
                                      <path id="Vector_4" d="M18.8974 0H10.5123V17.8537H18.8974V0ZM16.7073 15.8963H12.7024V2.0167H16.7073V15.8963Z" fill="#4D4B4C"></path>
                                      <path id="Vector_5" d="M23.2149 5.99077L27.2197 2.0167V17.913H29.4098V5.99077L33.3521 2.0167V17.913H35.5422V0H32.476L29.4098 3.08436V0H26.3436L21.0248 5.21968V17.913H23.2149V5.99077Z" fill="#4D4B4C"></path>
                                      <path id="Vector_6" d="M6.19494 17.913H8.38504V15.9556V0H5.31889L0 5.21968V15.8963V17.8537H2.19013H6.19494V17.913ZM2.2527 5.99077L6.25751 2.0167V15.8963H2.2527V5.99077Z" fill="#4D4B4C"></path>
                                  </g>
                                  <defs>
                                      <clipPath id="clip0_436_4639">
                                          <rect width="82" height="18" fill="white"></rect>
                                      </clipPath>
                                  </defs>
                              </svg>
                          </div>
                      </div>
                  </div>
                  <div className='crediting-left-bottom'>
                  {/* <input
                    type="text"
                    className="currency-input"
                    value={rawValue}
                    onChange={handleChange}
                    placeholder="0"
                    inputMode="numeric"
                  /> */}
                      <div className='crediting-form'>
                          <div className='Circe_Regular fcg fs15 crediting-form-title'>Стоимость дома</div>
                          <div className='crediting-form-input' key={rerenderHouseCost}>
                              <div className='crediting-form-input-outer'>
                                <input 
                                  className="Circe_Regular input-number-ruble" 
                                  // type="number" 
                                  inputMode="numeric"
                                  placeholder="0"
                                  onChange={setNumberHouseCost} 
                                  // onBlur={handleOnBlurHouseCost} 
                                  value={rawHouseCostValue} 
                                  /* min={houseCostLimit.min} */ 
                                  max={houseCostLimit.max} 
                                />
                                <span id="input-number-suffix" className="Circe_Regular" style={{ left: (suffixWidthHouseCost)+'px' }} >₽</span>
                              </div>
                              <ThemeProvider theme={theme}>
                              <Slider
                                className='crediting-form-input-slider'
                                size="small"
                                min={houseCostLimit.min}
                                max={houseCostLimit.max}
                                step={1000}
                                value={typeof houseCostValue === 'number' ? houseCostValue : houseCostLimit.min}
                                onChange={setPositionHouseCost}
                                // defaultValue={70}
                                // aria-label="Small"
                                // valueLabelDisplay="auto"
                              />
                              </ThemeProvider>
                          </div>
                          <div className='crediting-form-desc'></div>
                      </div>
                      <div className='crediting-form'>
                          <div className='Circe_Regular fcg fs15 crediting-form-title'>Первоначальный взнос</div>
                          <div className='crediting-form-input' key={rerenderInitialPayment}>
                              <div className='crediting-form-input-outer'>
                                <div className='Circe_Bold input-number-percent'>
                                  {initialPaymentPercentValue} %
                                </div>
                                <input 
                                  className="Circe_Regular input-number-ruble" 
                                  // type="number" 
                                  inputmode="numeric" 
                                  onChange={setNumberInitialPayment} 
                                  // onBlur={handleOnBlurInitialPayment} 
                                  value={rawInitialPaymentValue} 
                                  /* min={initialPaymentLimit.min} */ 
                                  max={initialPaymentLimit.max} 
                                />
                                <span id="input-number-suffix" className="Circe_Regular" style={{ left: (suffixWidthInitialPayment)+'px' }} >₽</span>
                              </div>
                              <ThemeProvider theme={theme}>
                              <Slider
                                className='crediting-form-input-slider'
                                size="small"
                                min={initialPaymentLimit.min}
                                max={initialPaymentLimit.max}
                                step={1000}
                                value={typeof initialPaymentValue === 'number' ? initialPaymentValue : initialPaymentLimit.min}
                                onChange={setPositionInitialPayment}
                                // defaultValue={70}
                                // aria-label="Small"
                                // valueLabelDisplay="auto"
                              />
                              </ThemeProvider>
                          </div>
                          <div className='Circe_Regular fcg fs15 crediting-form-desc'>Максимальная сумма кредита — {descMaxLoanAmount} ₽, в случае превышения первоначальный взнос будет автоматически увеличен.</div>
                      </div>
                      <div className='crediting-form'>
                          <div className='Circe_Regular fcg fs15 crediting-form-title'>Срок кредита</div>
                          <div className='crediting-form-input' key={rerenderLoanTerm}>
                            <div className='crediting-form-input-outer'>
                              <input 
                                className="Circe_Regular input-number-year" 
                                type="number" 
                                inputmode="numeric" 
                                onChange={setNumberLoanTerm} 
                                // onBlur={handleOnBlurLoanTerm}
                                value={loanTermValue} 
                                /* min={loanTermLimit.min} */ 
                                max={loanTermLimit.max}
                              />
                              <span id="input-number-suffix" className="Circe_Regular" style={{ left: (suffixWidthLoanTerm)+'px' }} >{yearFormLoanTerm}</span>
                            </div>
                            <ThemeProvider theme={theme}>
                            <Slider
                              className='crediting-form-input-slider'
                              size="small"
                              min={loanTermLimit.min}
                              max={loanTermLimit.max}
                              step={1}
                              value={typeof loanTermValue === 'number' ? loanTermValue : loanTermLimit.max}
                              onChange={setPositionLoanTerm}
                              // defaultValue={70}
                              // aria-label="Small"
                              // valueLabelDisplay="auto"
                            />
                            </ThemeProvider>
                          </div>
                          <div className='crediting-form-desc'></div>
                      </div>
                  </div>
              </div>
              <div className='crediting-right'>
                <div className="prev">
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="downarrow">
                      <g id="Group">
                        <path id="Vector" d="M9.40307 2.68189C9.27904 2.55786 9.07749 2.55786 8.95346 2.68189L4.99997 6.64313L1.03873 2.68189C0.914698 2.55786 0.713148 2.55786 0.589117 2.68189C0.465086 2.80592 0.465086 3.00747 0.589117 3.1315L4.76741 7.3098C4.82943 7.37181 4.90695 7.40282 4.99222 7.40282C5.06974 7.40282 5.15501 7.37181 5.21702 7.3098L9.39532 3.1315C9.5271 3.00747 9.5271 2.80592 9.40307 2.68189Z" fill="#4C4A4C"></path>
                      </g>
                    </g>
                  </svg>
                </div>
                <div className="next">
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="downarrow">
                      <g id="Group">
                        <path id="Vector" d="M9.40307 2.68189C9.27904 2.55786 9.07749 2.55786 8.95346 2.68189L4.99997 6.64313L1.03873 2.68189C0.914698 2.55786 0.713148 2.55786 0.589117 2.68189C0.465086 2.80592 0.465086 3.00747 0.589117 3.1315L4.76741 7.3098C4.82943 7.37181 4.90695 7.40282 4.99222 7.40282C5.06974 7.40282 5.15501 7.37181 5.21702 7.3098L9.39532 3.1315C9.5271 3.00747 9.5271 2.80592 9.40307 2.68189Z" fill="#4C4A4C"></path>
                      </g>
                    </g>
                  </svg>
                </div>
                {/* <div className="pagination"></div> */}
                <Swiper
                  centeredSlides={false}
                  grabCursor={true}
                  // slidesPerView={1}
                  breakpoints={{
                    1250.98: { slidesPerView: 2, slidesPerGroup: 1, },
                    920.98: { slidesPerView: 1, slidesPerGroup: 1, },
                    768.98: { slidesPerView: 2, slidesPerGroup: 1, },
                    0: { slidesPerView: 1, slidesPerGroup: 1, },
                  }}
                  navigation={{ prevEl: '.prev', nextEl: '.next', }}
                  spaceBetween={20}
                  keyboard={{ enabled: true }}
                  // pagination={{ clickable: true, el: '.pagination', }}
                  onSwiper={setSwiperRefActiveObject}
                  freeMode={true}
                  virtual={false}
                  modules={[Virtual, Navigation, Pagination, Mousewheel, Keyboard]}
                  className="tab-of-cards mySwiper"
                >
                  <SwiperSlide key={'card_facility_0'} virtualIndex={0} className={'card '+(pickedMortgage == 'base' ? 'active-card' : '')}>
                    <div className='card-content'>
                      {pickedMortgage == 'base' ? 
                        <div className="slide-credit__decor">
                          <svg width="100" height="39" viewBox="0 0 100 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="Group"><g id="Group_2"><g id="Group_3"><path id="Vector" d="M3.00091 39.0003L0 35.6287L37.3301 2.72656L47.0508 11.7108L43.9708 15.0094L37.2589 8.80597L3.00091 39.0003Z" fill="#67AA93"/></g></g><path id="Vector_2" d="M19.1616 38.6853L16.0994 35.369L39.5511 13.8867L64.2532 34.1199L61.3768 37.5998L39.7195 19.8561L19.1616 38.6853Z" fill="#67AA93"/><path id="Vector_3" d="M32.3395 37.2419L29.3386 33.8723L60.4401 6.41504L63.441 9.78458L32.3395 37.2419Z" fill="#67AA93"/><g id="Group_4"><path id="Vector_4" d="M44.6702 37.2422L41.6573 33.8825L79.7999 0L82.8128 3.35983L44.6702 37.2422Z" fill="#67AA93"/><path id="Vector_5" d="M96.6355 38.2288L76.0936 15.4446L79.4624 12.4355L100 35.2197L96.6355 38.2288Z" fill="#67AA93"/><path id="Vector_6" d="M74.328 36.9853H69.0462V27.6387H74.328V36.9853Z" fill="#67AA93"/><path id="Vector_7" d="M83.4145 36.9853H78.1328V27.6387H83.4145V36.9853Z" fill="#67AA93"/></g></g>
                          </svg>
                        </div>
                      : null}
                      <div className='Manrope_Bold fcldg fs32 card-content-title'>
                        {'Базовая ипотека'}
                      </div>
                      <div className='card-content-data'>
                        <div className='card-content-info'>
                          <div className='Circe_Regular fcg fs15'>
                            {'Ежемесячный платеж'}
                          </div>
                          <div className='Manrope_Bold fcldg fs24'>
                            {Object.keys(info).length ?
                              <>{calculateLoan(houseCostValue, initialPaymentValue, loanTermValue, info[pickedType]['base'].percent, 'monthlyPayment').toLocaleString('ru')} ₽</>
                            : null}
                          </div>
                        </div>
                        <div className='card-content-info'>
                          <div className='Circe_Regular fcg fs15'>
                            {'Переплата'}
                          </div>
                          <div className='Manrope_Bold fcldg fs24'>
                            {Object.keys(info).length ?
                              <>{calculateLoan(houseCostValue, initialPaymentValue, loanTermValue, info[pickedType]['base'].percent, 'overpayment').toLocaleString('ru')} ₽</>
                            : null}
                          </div>
                        </div>
                        <div className='card-content-info'>
                          <div className='Circe_Regular fcg fs15'>
                            {'Процентная ставка'}
                          </div>
                          <div className='Manrope_Bold fcldg fs24'>
                            {Object.keys(info).length ?
                              <>{info[pickedType]['base'].percent} %</>
                            : null}
                          </div>
                        </div>
                      </div>
                      <div className='card-content-action'>
                        <button className='Manrope_Regular fs16' onClick={() => setPickedMortgage('base')}>{pickedMortgage == 'base' ? 'Вы выбрали' : 'Выбрать'}</button>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide key={'card_facility_1'} virtualIndex={1} className={'card '+(pickedMortgage == 'gos' ? 'active-card' : '')}>
                    <div className='card-content'>
                      {pickedMortgage == 'gos' ? 
                        <div className="slide-credit__decor">
                          <svg width="100" height="39" viewBox="0 0 100 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="Group"><g id="Group_2"><g id="Group_3"><path id="Vector" d="M3.00091 39.0003L0 35.6287L37.3301 2.72656L47.0508 11.7108L43.9708 15.0094L37.2589 8.80597L3.00091 39.0003Z" fill="#67AA93"/></g></g><path id="Vector_2" d="M19.1616 38.6853L16.0994 35.369L39.5511 13.8867L64.2532 34.1199L61.3768 37.5998L39.7195 19.8561L19.1616 38.6853Z" fill="#67AA93"/><path id="Vector_3" d="M32.3395 37.2419L29.3386 33.8723L60.4401 6.41504L63.441 9.78458L32.3395 37.2419Z" fill="#67AA93"/><g id="Group_4"><path id="Vector_4" d="M44.6702 37.2422L41.6573 33.8825L79.7999 0L82.8128 3.35983L44.6702 37.2422Z" fill="#67AA93"/><path id="Vector_5" d="M96.6355 38.2288L76.0936 15.4446L79.4624 12.4355L100 35.2197L96.6355 38.2288Z" fill="#67AA93"/><path id="Vector_6" d="M74.328 36.9853H69.0462V27.6387H74.328V36.9853Z" fill="#67AA93"/><path id="Vector_7" d="M83.4145 36.9853H78.1328V27.6387H83.4145V36.9853Z" fill="#67AA93"/></g></g>
                          </svg>
                        </div>
                      : null}
                      <div className='Manrope_Bold fcldg fs32 card-content-title'>
                        {'Гос. поддержка'}
                      </div>
                      <div className='card-content-data'>
                        <div className='card-content-info'>
                          <div className='Circe_Regular fcg fs15'>
                            {'Ежемесячный платеж'}
                          </div>
                          <div className='Manrope_Bold fcldg fs24'>
                            {Object.keys(info).length ?
                              <>{calculateLoan(houseCostValue, initialPaymentValue, loanTermValue, info[pickedType]['gos'].percent, 'monthlyPayment').toLocaleString('ru')} ₽</>
                            : null}
                          </div>
                        </div>
                        <div className='card-content-info'>
                          <div className='Circe_Regular fcg fs15'>
                            {'Переплата'}
                          </div>
                          <div className='Manrope_Bold fcldg fs24'>
                            {Object.keys(info).length ?
                              <>{calculateLoan(houseCostValue, initialPaymentValue, loanTermValue, info[pickedType]['gos'].percent, 'overpayment').toLocaleString('ru')} ₽</>
                            : null}
                          </div>
                        </div>
                        <div className='card-content-info'>
                          <div className='Circe_Regular fcg fs15'>
                            {'Процентная ставка'}
                          </div>
                          <div className='Manrope_Bold fcldg fs24'>
                            {Object.keys(info).length ?
                              <>{info[pickedType]['gos'].percent} %</>
                            : null}
                          </div>
                        </div>
                      </div>
                      <div className='card-content-action'>
                        <button className='Manrope_Regular fs16' onClick={() => setPickedMortgage('gos')}>{pickedMortgage == 'gos' ? 'Вы выбрали' : 'Выбрать'}</button>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide key={'card_facility_2'} virtualIndex={2} className={'card '+(pickedMortgage == 'fam' ? 'active-card' : '')}>
                    <div className='card-content'>
                      {pickedMortgage == 'fam' ? 
                        <div className="slide-credit__decor">
                          <svg width="100" height="39" viewBox="0 0 100 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="Group"><g id="Group_2"><g id="Group_3"><path id="Vector" d="M3.00091 39.0003L0 35.6287L37.3301 2.72656L47.0508 11.7108L43.9708 15.0094L37.2589 8.80597L3.00091 39.0003Z" fill="#67AA93"/></g></g><path id="Vector_2" d="M19.1616 38.6853L16.0994 35.369L39.5511 13.8867L64.2532 34.1199L61.3768 37.5998L39.7195 19.8561L19.1616 38.6853Z" fill="#67AA93"/><path id="Vector_3" d="M32.3395 37.2419L29.3386 33.8723L60.4401 6.41504L63.441 9.78458L32.3395 37.2419Z" fill="#67AA93"/><g id="Group_4"><path id="Vector_4" d="M44.6702 37.2422L41.6573 33.8825L79.7999 0L82.8128 3.35983L44.6702 37.2422Z" fill="#67AA93"/><path id="Vector_5" d="M96.6355 38.2288L76.0936 15.4446L79.4624 12.4355L100 35.2197L96.6355 38.2288Z" fill="#67AA93"/><path id="Vector_6" d="M74.328 36.9853H69.0462V27.6387H74.328V36.9853Z" fill="#67AA93"/><path id="Vector_7" d="M83.4145 36.9853H78.1328V27.6387H83.4145V36.9853Z" fill="#67AA93"/></g></g>
                          </svg>
                        </div>
                      : null}
                      <div className='Manrope_Bold fcldg fs32 card-content-title'>
                        {'Семейная ипотека'}
                      </div>
                      <div className='card-content-data'>
                        <div className='card-content-info'>
                          <div className='Circe_Regular fcg fs15'>
                            {'Ежемесячный платеж'}
                          </div>
                          <div className='Manrope_Bold fcldg fs24'>
                            {Object.keys(info).length ?
                              <>{calculateLoan(houseCostValue, initialPaymentValue, loanTermValue, info[pickedType]['fam'].percent, 'monthlyPayment').toLocaleString('ru')} ₽</>
                            : null}
                          </div>
                        </div>
                        <div className='card-content-info'>
                          <div className='Circe_Regular fcg fs15'>
                            {'Переплата'}
                          </div>
                          <div className='Manrope_Bold fcldg fs24'>
                            {Object.keys(info).length ?
                              <>{calculateLoan(houseCostValue, initialPaymentValue, loanTermValue, info[pickedType]['fam'].percent, 'overpayment').toLocaleString('ru')} ₽</>
                            : null}
                          </div>
                        </div>
                        <div className='card-content-info'>
                          <div className='Circe_Regular fcg fs15'>
                            {'Процентная ставка'}
                          </div>
                          <div className='Manrope_Bold fcldg fs24'>
                            {Object.keys(info).length ?
                              <>{info[pickedType]['fam'].percent} %</>
                            : null}
                          </div>
                        </div>
                      </div>
                      <div className='card-content-action'>
                        <button className='Manrope_Regular fs16' onClick={() => setPickedMortgage('fam')}>{pickedMortgage == 'fam' ? 'Вы выбрали' : 'Выбрать'}</button>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide key={'card_facility_3'} virtualIndex={3} className={'card '+(pickedMortgage == 'it' ? 'active-card' : '')}>
                    <div className='card-content'>
                      {pickedMortgage == 'it' ? 
                        <div className="slide-credit__decor">
                          <svg width="100" height="39" viewBox="0 0 100 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="Group"><g id="Group_2"><g id="Group_3"><path id="Vector" d="M3.00091 39.0003L0 35.6287L37.3301 2.72656L47.0508 11.7108L43.9708 15.0094L37.2589 8.80597L3.00091 39.0003Z" fill="#67AA93"/></g></g><path id="Vector_2" d="M19.1616 38.6853L16.0994 35.369L39.5511 13.8867L64.2532 34.1199L61.3768 37.5998L39.7195 19.8561L19.1616 38.6853Z" fill="#67AA93"/><path id="Vector_3" d="M32.3395 37.2419L29.3386 33.8723L60.4401 6.41504L63.441 9.78458L32.3395 37.2419Z" fill="#67AA93"/><g id="Group_4"><path id="Vector_4" d="M44.6702 37.2422L41.6573 33.8825L79.7999 0L82.8128 3.35983L44.6702 37.2422Z" fill="#67AA93"/><path id="Vector_5" d="M96.6355 38.2288L76.0936 15.4446L79.4624 12.4355L100 35.2197L96.6355 38.2288Z" fill="#67AA93"/><path id="Vector_6" d="M74.328 36.9853H69.0462V27.6387H74.328V36.9853Z" fill="#67AA93"/><path id="Vector_7" d="M83.4145 36.9853H78.1328V27.6387H83.4145V36.9853Z" fill="#67AA93"/></g></g>
                          </svg>
                        </div>
                      : null}
                      <div className='Manrope_Bold fcldg fs32 card-content-title'>
                        {'IT ипотека'}
                      </div>
                      <div className='card-content-data'>
                        <div className='card-content-info'>
                          <div className='Circe_Regular fcg fs15'>
                            {'Ежемесячный платеж'}
                          </div>
                          <div className='Manrope_Bold fcldg fs24'>
                            {Object.keys(info).length ?
                              <>{calculateLoan(houseCostValue, initialPaymentValue, loanTermValue, info[pickedType]['it'].percent, 'monthlyPayment').toLocaleString('ru')} ₽</>
                            : null}
                          </div>
                        </div>
                        <div className='card-content-info'>
                          <div className='Circe_Regular fcg fs15'>
                            {'Переплата'}
                          </div>
                          <div className='Manrope_Bold fcldg fs24'>
                            {Object.keys(info).length ?
                              <>{calculateLoan(houseCostValue, initialPaymentValue, loanTermValue, info[pickedType]['it'].percent, 'overpayment').toLocaleString('ru')} ₽</>
                            : null}
                          </div>
                        </div>
                        <div className='card-content-info'>
                          <div className='Circe_Regular fcg fs15'>
                            {'Процентная ставка'}
                          </div>
                          <div className='Manrope_Bold fcldg fs24'>
                            {Object.keys(info).length ?
                              <>{info[pickedType]['it'].percent} %</>
                            : null}
                          </div>
                        </div>
                      </div>
                      <div className='card-content-action'>
                        <button className='Manrope_Regular fs16' onClick={() => setPickedMortgage('it')}>{pickedMortgage == 'it' ? 'Вы выбрали' : 'Выбрать'}</button>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
          </div>
      </div>
  );
}

export default App;